import { DragDropFileList, Label } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { getFileNameAndExtension } from '@/helpers'
import { api, SUPPLY_ORDER_URL } from '@/services'

import { SupplyOrderProps } from '@/types'

import type { ExternalDocumentsFormProps } from './external-documents-form.type'

import styles from './external-documents-form.module.css'

export const ExternalDocumentsForm = ({
  onChange,
  values = {} as SupplyOrderProps,
  documentsList,
  onSuccessUpload,
}: ExternalDocumentsFormProps) => {
  const { t } = useTranslation('screenSupplyOrderDetail')

  const onChangeValues = (
    keyParam: keyof SupplyOrderProps,
    value?: string | number,
  ) => {
    onChange({
      ...values,
      [keyParam]: value,
    })
    onSuccessUpload?.()
  }

  const getFileValue = (keyParam: keyof SupplyOrderProps) => {
    if (!values?.[keyParam]) {
      return []
    }

    const { fileName, extension } = getFileNameAndExtension(
      values?.[keyParam] as string,
    )

    return [
      {
        id: new Date().getTime(),
        name: `${fileName}.${extension}`,
        url: values?.[keyParam] as string,
        uploaded: true,
        preview: values?.[keyParam] as string,
      },
    ]
  }

  return (
    <div className={styles.content}>
      {documentsList.map(
        ({ file, configRequest, fileTranslationId, translationsConfig }) => (
          <div className={styles.field}>
            <Label>{t(fileTranslationId)}</Label>

            <DragDropFileList
              axiosInstance={api}
              urlAdd={SUPPLY_ORDER_URL(values?.uuid || '')}
              configsRequest={configRequest}
              initialData={getFileValue(file)}
              successedUpload={(value) =>
                onChangeValues(
                  file,
                  value?.[configRequest.fileField]
                    ? `${value?.[configRequest.fileField]}`
                    : '',
                )
              }
              translations={
                translationsConfig || {
                  clickToUpload: t('tabDocumentsExternalFormUploadButton'),
                  dragFile: t('tabDocumentsExternalFormUploadDrag'),
                  sizeFile: t('tabDocumentsExternalFormUploadSize'),
                }
              }
            />
          </div>
        ),
      )}
    </div>
  )
}
